import React from 'react';
import { IntlProvider } from 'react-intl';
import { ConfigProvider } from 'antd';
import { useLocaleState } from '@/containers/LanguageProvider/hooks/useLocaleState';
import { ANTD_LOCALE_MAP } from './constants';

interface Props {
  messages: Record<string, Record<string, string>>;
  children: React.ReactNode;
}

export const LanguageProvider: React.FC<Props> = ({ messages, children }) => {
  const { locale } = useLocaleState();

  return (
    <IntlProvider
      locale={locale}
      messages={messages[locale]}
      defaultRichTextElements={{
        strong: str => <strong>{str}</strong>,
      }}
      onError={e => {
        if (import.meta.env.PROD && e.code === 'MISSING_TRANSLATION') return;
        if (!import.meta.env.PROD) console.warn(e);
      }}
    >
      <ConfigProvider locale={ANTD_LOCALE_MAP[locale]}>
        {React.Children.only(children as React.ReactElement)}
      </ConfigProvider>
    </IntlProvider>
  );
};
